<form [formGroup]="form" class="flex flex-col gap-6">
  <p class="dialog-description">{{ data.description }}</p>

  <div class="flex flex-col gap-2">
    <label
      for="admin-panel-user-action-justification"
      appRequiredLabel="justification"
      class="dialog-label"
    >
      Uzasadnienie
    </label>
    <textarea
      id="admin-panel-user-action-justification"
      rows="6"
      formControlName="justification"
      class="dialog-textarea"
      maxlength="4000"
    ></textarea>
  </div>

  <div class="flex justify-end gap-4">
    <p-button
      label="Anuluj"
      styleClass="customInfoButton outlined"
      (click)="dialogRef.close()"
    />
    <p-button
      [label]="data.confirmLabel"
      styleClass="customInfoButton"
      [disabled]="!canConfirm()"
      (click)="confirm()"
    />
  </div>
</form>
